import React from 'react';

const IconFail = props => (<svg viewBox="0 0 24 24" width="24px" height="24px" {...props}>
  <path fill="#ffffff" d="M12 0C5.373 0 0 5.373 0 12c0 6.627 5.373 12 12 12c6.627 0 12-5.373 12-12C24 5.373 18.627 0 12 0z M12 22 C6.486 22 2 17.514 2 12C2 6.486 6.486 2 12 2c5.514 0 10 4.486 10 10C22 17.514 17.514 22 12 22z" />
  <path fill="#ffffff" d="M11 13.896h2l0-8.476h-2L11 13.896z" />
  <path fill="#ffffff" d="M11 18.813h2l0-2.844h-2L11 18.813z" />
</svg>);

export default IconFail;
